module.exports = __webpack_public_path__ + "img/type5.dada4219.png";